"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CANVAS_IFRAME = exports.CANVAS_INLINE = void 0;
var CANVAS_INLINE = 'canvasinline';
exports.CANVAS_INLINE = CANVAS_INLINE;
var CANVAS_IFRAME = 'canvasiframe';
exports.CANVAS_IFRAME = CANVAS_IFRAME;